import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { FaBusinessTime, FaUser, FaChevronDown, FaHome, FaLandmark, FaUserMd, FaGlobe  } from "react-icons/fa";
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai'; 


const NavigationBar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const toggleProductDropdown = () => {
    setIsProductDropdownOpen(!isProductDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProductDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  const handleGetInTouchClick = () => {
    navigate("/login");
  };

  const handleLoanSelection = (loanType) => {
    navigate(`/otp-verification/${loanType}-loan`, {
      state: { loanType },
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
    <div className="navbar-logo">
      <div onClick={() => navigate("/")}>
        <img src={logo} alt="Resonance Logo" className="navbar-logo-image" />
      </div>
      <div className="navbar-logo-text">
        <p>The Most <br />Successful Approvals <br />start from here</p>
      </div>
    </div>

      {!isNavOpen ? (
        <div className="navbar-menu-icon" onClick={toggleNav}>
         <AiOutlineMenuUnfold />
        </div>
      ) : (
        <div className="navbar-menu-close" onClick={toggleNav}>
         <AiOutlineMenuFold />
        </div>
      )}

    <nav className={`nav-landing ${isNavOpen ? "active" : ""}`}>
      <ul className="nav-section-text">
        {!isMobile ? (
          <li
            className="dropdown"
            onClick={toggleProductDropdown}
            ref={dropdownRef}
          >
            Products
            <FaChevronDown
              className={`dropdown-arrow ${
                isProductDropdownOpen ? "open" : ""
              }`}
            />
            {isProductDropdownOpen && (
              <div className="new-dropdown-menu-profile animated-dropdown">
                <div
                      className="new-dropdown-menu-item-profile"
                      onClick={() => handleLoanSelection("home")}
                    >
                      <FaHome className="new-menu-icon-loan" />
                      <p>Home Loan</p>
                    </div>
                    
                    <div
                      className="new-dropdown-menu-item-profile"
                      onClick={() => handleLoanSelection("personal")}
                    >
                      <FaUser className="new-menu-icon-loan" />
                      <p>Personal Loan</p>
                    </div>
                    <div
                      className="new-dropdown-menu-item-profile"
                      onClick={() => handleLoanSelection("business")}
                    >
                      <FaBusinessTime className="new-menu-icon-loan" />
                      <p>Business Loan</p>
                    </div>
                    <div
                      className="new-dropdown-menu-item-profile"
                      onClick={() => handleLoanSelection("mortgage")}
                    >
                      <FaLandmark className="new-menu-icon-loan" />
                      <p>Mortgage Loan</p>
                    </div>
                    <div
                      className="new-dropdown-menu-item-profile"
                      onClick={() => handleLoanSelection("doctor")}
                    >
                      <FaUserMd className="new-menu-icon-loan" />
                      <p>Doctor Loan</p>
                    </div>
                                    <div
                      className="new-dropdown-menu-item-profile"
                      onClick={() => handleLoanSelection("nri")}
                    >
                      <FaGlobe className="new-menu-icon-loan" />
                      <p>NRI Loan</p>
                    </div>
              </div>
            )}
          </li>
        ) : (
          <>
            <li
              className="new-dropdown-menu-item-profile"
              onClick={() => handleLoanSelection("home")}
            >
              <p><FaHome className="new-menu-icon-loan" />Home Loan</p>
            </li>
            <li
              className="new-dropdown-menu-item-profile"
              onClick={() => handleLoanSelection("personal")}
            >  
              <p><FaUser className="new-menu-icon-loan" />Personal Loan</p>
            </li>
            <li
              className="new-dropdown-menu-item-profile"
              onClick={() => handleLoanSelection("business")}
            >
              <p><FaBusinessTime className="new-menu-icon-loan" />Business Loan</p>
            </li>
            <li
              className="new-dropdown-menu-item-profile"
              onClick={() => handleLoanSelection("mortgage")}
            >
              <p><FaLandmark className="new-menu-icon-loan" />Mortgage Loan</p>
            </li>
            <li
              className="new-dropdown-menu-item-profile"
              onClick={() => handleLoanSelection("doctor")}
            >
              <p><FaUserMd className="new-menu-icon-loan" />Doctor Loan</p>
            </li>
            <li
              className="new-dropdown-menu-item-profile"
              onClick={() => handleLoanSelection("nri")}
            >
              <p><FaGlobe className="new-menu-icon-loan" />NRI Loan</p>
            </li>
          </>
        )}

        <li className="nav-get-in-touch">
          <button
            className="get-in-touch-landing"
            onClick={handleGetInTouchClick}
          >
            <span className="spin-text">Login</span>
          </button>
        </li>
      </ul>
    </nav>

    </header>
  );
};

export default NavigationBar;
